export default {
  install(Vue, opts = {}) {
    Vue.prototype.$setLoad = (value = false) => {
      opts.commit('setLoad', value)
    }
  },
}
